const debtor_group = {
	add_button: "Schuldner hinzufügen",
	add_debtor_dialog: {
		description: "Schuldner hinzufügen",
		form: {
			debtor_code: "Schuldner-Code",
		},
		title: "Schuldner hinzufügen",
	},
	delete_dialog: {
		description: "Möchten Sie den Schuldner <strong>{{name}}</strong> wirklich trennen?",
		title: "Schuldner trennen",
	},
	status: {
		add_debtor: {
			success:
				"Schuldner <strong>{{debtor_code}}</strong> erfolgreich zur Schuldnergruppe hinzugefügt.",
			unknown:
				"Der gewählte Schuldner kann derzeit nicht hinzugefügt werden. Bitte versuchen Sie es später erneut.",
		},
		delete_debtor: {
			not_empty: "Die Schuldnergruppe ist nicht leer. Bitte trennen Sie zuerst alle Schuldner.",
			success: "Schuldner erfolgreich aus der Schuldnergruppe entfernt.",
			unknown:
				"Der gewählte Schuldner kann derzeit nicht entfernt werden. Bitte versuchen Sie es später erneut.",
		},
	},
	title: "Schuldnergruppe",
};

export default debtor_group;
